module.exports = __webpack_public_path__ + "media/images/logo-ultrasync-78d24738292b0fdb7ef565952a03f302.png";